import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { Row, InitialAvatarIcon, BaseText } from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

import { IMarketStatus } from '@/modules/catalog/services/products';

interface Props {
  status: IMarketStatus;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MarketStatus',
  props: {
    status: null
  },
  setup(__props: any) {

const props = __props as {
  status: IMarketStatus;
};



const marketIconClass = computed(() => {
  return props.status.isMarketOpen
    ? 'market-status__icon-open'
    : 'market-status__icon-closed';
});

return { __sfc: true,props, marketIconClass, Row, InitialAvatarIcon, BaseText, NebraskaColors }
}

})